import { z } from "zod";

// Form checks for the account screens (specs/11 FR-57, FR-61). Supabase enforces the same
// minimum length on its side; 72 is the most bcrypt uses.

export const passwordSchema = z.string().min(10, { message: "short" }).max(72, { message: "long" });

export type PasswordProblem = "short" | "long";

export function checkPassword(password: string): PasswordProblem | null {
  const result = passwordSchema.safeParse(password);
  return result.success ? null : (result.error.issues[0].message as PasswordProblem);
}

export const isEmail = (email: string) => z.string().email().safeParse(email.trim()).success;
